export default "__VITE_ASSET__BhPRZD2o__"